import { useState } from "react";
import { PlusOutlined, UploadOutlined } from "@ant-design/icons";
import {
  Button,
  Col,
  Form,
  Modal,
  Row,
  Upload,
  UploadFile,
  message,
} from "antd";
import { callCreateUpload } from "../../../../config/api";
import { RcFile, UploadProps } from "antd/es/upload";

const AddUpload = ({ handleFetchUpload }: any): JSX.Element => {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [fileList, setFileList] = useState<UploadFile[]>([]);
  const [previewImage, setPreviewImage] = useState("");
  const [previewOpen, setPreviewOpen] = useState<boolean>(false);
  const handleCancelImage = () => setPreviewOpen(false);

  const [form] = Form.useForm();
  const showModal = () => {
    setOpen(true);
  };

  const onFinish = async (values: any) => {
    setLoading(true);

    if (fileList?.length > 0) {
      const result = await callCreateUpload(fileList[0]?.thumbUrl);
      if (result.statusCode === 201) {
        setOpen(false);
        handleFetchUpload();
        message.success("Thêm ảnh mới thành công !");
      } else {
        message.error("Thêm ảnh mới thất bại !");
      }
    }
    setLoading(false);
  };

  const onClose = () => {
    setOpen(false);
  };

  const getBase64 = (file: RcFile): Promise<string> =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result as string);
      reader.onerror = (error) => reject(error);
    });

  const handlePreview = async (file: UploadFile) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj as any);
    }

    setPreviewImage(file.url || (file.preview as string));
    setPreviewOpen(true);
  };

  const handleChange: UploadProps["onChange"] = ({ fileList: newFileList }) => {
    // Giữ chỉ một tệp trong fileList
    setFileList(newFileList?.slice(-1));
  };

  return (
    <>
      <Button type="primary" onClick={showModal} icon={<PlusOutlined />}>
        Thêm mới
      </Button>
      <Modal
        title="Thêm hình ảnh mới"
        open={open}
        onOk={() => {
          form.submit();
        }}
        okText="Tạo mới"
        cancelText="Hủy"
        confirmLoading={loading}
        maskClosable={false}
        width={840}
        onCancel={onClose}>
        <Form
          layout="vertical"
          form={form}
          onFinish={onFinish}
          hideRequiredMark>
          <Row gutter={16}>
            <Col xs={24} style={{ textAlign: "center" }}>
              <Form.Item name="image" label={"Hình ảnh"}>
                <Upload
                  action="https://run.mocky.io/v3/435e224c-44fb-4773-9faf-380c5e6a2188"
                  listType="picture-card"
                  fileList={fileList}
                  onPreview={handlePreview}
                  onChange={handleChange}>
                  {fileList.length >= 1 ? null : (
                    <>
                      <UploadOutlined /> {"Tải ảnh lên"}
                    </>
                  )}
                </Upload>
                <Modal
                  open={previewOpen}
                  footer={null}
                  onCancel={handleCancelImage}>
                  <img
                    alt="example"
                    style={{ width: "100%" }}
                    src={previewImage}
                  />
                </Modal>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
    </>
  );
};

export default AddUpload;
